import { ColorOrCustom, dynamicStyling } from 'styles';
import { cascadeEval } from 'utils/conditions';

interface TripleLoaderProps {
  outerColor?: ColorOrCustom;
  middleColor?: ColorOrCustom;
  innerColor?: ColorOrCustom;
  size?: number;
}

export function TripleRingLoader({
  innerColor,
  middleColor,
  outerColor,
  size = 108,
}: TripleLoaderProps) {
  const border = cascadeEval([
    { is: size <= 30, then: 'border-[1px]' },
    { is: size <= 65, then: 'border-2' },
    { is: true, then: 'border-[3px]' },
  ]);

  const className = `absolute rounded-full ${border} animate-spin border-transparent border-t-current`;

  return (
    <div
      {...dynamicStyling({
        size,

        className: 'inline-flex items-center justify-center',
      })}
    >
      <div
        {...dynamicStyling({
          size,
          color: outerColor || 'primary',

          className,

          style: { animationDuration: '1s' },
        })}
      />

      <div
        {...dynamicStyling({
          size: size * 0.8,
          color: middleColor || 'primary-dark',

          className,
          style: { animationDuration: '1.5s' },
        })}
      />

      <div
        {...dynamicStyling({
          size: size * 0.6,
          color: innerColor || 'primary',

          className,
          style: { animationDuration: '0.75s' },
        })}
      />
    </div>
  );
}
